// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase:{
		apiKey: "AIzaSyBdYCGjlvcxbD4PcHcv1VJQ5O1ivpHrtJU",
    authDomain: "brewboard-664c3.firebaseapp.com",
    databaseURL: "https://brewboard-664c3.firebaseio.com",
    projectId: "brewboard-664c3",
    storageBucket: "brewboard-664c3.appspot.com",
    messagingSenderId: "9153292778"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts